<template>
  <div>
    <BaseLoader v-if="$statsigState.loading" size="xl" />
    <QueueBusterNew v-else-if="$statsigState.initialized && isFeatureEnabled" />
    <QueueBuster v-else />
  </div>
</template>
<script>
  import QueueBusterNew from "./QueueBusterNew";
  import QueueBuster from "./QueueBuster";
  import BaseLoader from "@/components/BaseLoader.vue";
  import { useFeatureFlags } from "@/hooks/useFeatureFlags";
  import { Feature_Flags } from "@/enums/globals";
  
  export default {
    name: "FeatureFlagSwitcherQueueBuster",
    components: {
      BaseLoader,
      QueueBusterNew,
      QueueBuster
    },
    computed: {
      isFeatureEnabled() {
        const { isFeatureEnabled } = useFeatureFlags();
        return isFeatureEnabled(Feature_Flags.PORTAL_QR_ORDERING_REVAMP);
      },
    },
  };
</script>
  